import React from 'react';
import { pick } from 'lodash';
import LineSpacingButton from './LineSpacingButton.js';
import { LINE_SPACING_TYPE } from '../types.js';
import LineSpacingIcon from '../icons/LineSpacingIcon.js';
import { P as Panel } from '../LineSpacingPanel-f2d89955.js';
import { FORMATTING_BUTTONS, decorateComponentWithProps, isAtomicBlockFocused, BUTTON_TYPES, mergeBlockData, getModalStyles, getAnchorBlockData } from 'wix-rich-content-editor-common';
import 'wix-rich-content-common';
import 'react-modal';
import 'classnames';
import 'prop-types';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const lineHeight = "line-height";
const spaceBefore = "padding-top";
const spaceAfter = "padding-bottom";
const createToolbar = (config) => {
  const { getEditorState, setEditorState, helpers, isMobile, theme } = config;
  let oldEditorState;
  let spacing;
  const updateSpacing = (spacing2) => {
    const dynamicStyles = spacing2;
    const newEditorState = mergeBlockData(oldEditorState || getEditorState(), { dynamicStyles });
    setEditorState(newEditorState);
  };
  const getBlockSpacing = (editorState) => {
    const { dynamicStyles = {} } = getAnchorBlockData(editorState);
    return pick(dynamicStyles, [lineHeight, spaceBefore, spaceAfter]);
  };
  const save = (spacing2) => {
    var _a;
    (_a = helpers == null ? void 0 : helpers.closeModal) == null ? void 0 : _a.call(helpers);
    if (spacing2) {
      updateSpacing(spacing2);
    } else {
      setEditorState(oldEditorState);
    }
  };
  const cancel = () => {
    var _a;
    (_a = helpers == null ? void 0 : helpers.closeModal) == null ? void 0 : _a.call(helpers);
    setEditorState(oldEditorState);
  };
  const LineSpacingPanel = ({ closeCustomModal, onSelect }) => {
    oldEditorState = getEditorState();
    spacing = getBlockSpacing(oldEditorState);
    return /* @__PURE__ */ React.createElement(
      Panel,
      __spreadValues({
        onChange: (args) => {
          updateSpacing(args);
          onSelect && onSelect(args);
        },
        onSave: (args) => {
          save(args);
          onSelect && onSelect(args);
          closeCustomModal && closeCustomModal();
        },
        onCancel: () => {
          cancel();
          closeCustomModal && closeCustomModal();
        },
        spacing
      }, config)
    );
  };
  const modalStylesFn = (ref) => {
    const { bottom, left } = ref.getBoundingClientRect();
    return isMobile ? {
      content: {
        position: "absolute",
        left: "0px",
        right: "0px",
        bottom: "0",
        border: "none",
        background: "white",
        overflow: "auto",
        outline: "none",
        padding: "0px",
        width: "100%",
        zIndex: 6,
        top: "auto",
        transform: "translateY(0)",
        margin: 0
      }
    } : {
      content: {
        display: "inline-table",
        transform: "translateY(0)",
        minHeight: "116px",
        height: "auto",
        position: "absolute",
        minWidth: "216px",
        maxWidth: "360px",
        width: "auto",
        top: bottom,
        left: left - 15,
        borderRadius: "6px",
        border: "1px solid #ededed",
        margin: "0",
        background: "#fff"
      },
      overlay: {
        background: "transparent"
      }
    };
  };
  const openLineSpacingModal = ({ ref, render }) => {
    var _a;
    if (render) {
      render(LineSpacingPanel);
    } else {
      const modalStyles = getModalStyles({
        customStyles: modalStylesFn(ref),
        fullScreen: false,
        isMobile
      });
      (_a = helpers == null ? void 0 : helpers.openModal) == null ? void 0 : _a.call(helpers, {
        modalStyles,
        helpers,
        isMobile,
        modalElement: LineSpacingPanel,
        theme
      });
    }
  };
  return {
    TextButtonMapper: () => ({
      [FORMATTING_BUTTONS.LINE_SPACING]: {
        component: decorateComponentWithProps(LineSpacingButton, config[LINE_SPACING_TYPE]),
        externalizedButtonProps: {
          onClick: ({ ref, render }) => openLineSpacingModal({ ref, render }),
          isActive: () => false,
          isDisabled: () => isAtomicBlockFocused(config.getEditorState()),
          getIcon: () => {
            var _a, _b, _c;
            return ((_c = (_b = (_a = config[LINE_SPACING_TYPE]) == null ? void 0 : _a.toolbar) == null ? void 0 : _b.icons) == null ? void 0 : _c.InsertPluginButtonIcon) || (() => {
              var _a2, _b2;
              return LineSpacingIcon({
                newFormattingToolbar: (_b2 = (_a2 = config == null ? void 0 : config.experiments) == null ? void 0 : _a2.newFormattingToolbar) == null ? void 0 : _b2.enabled
              });
            });
          },
          tooltip: config.t("LineSpacingButton_Tooltip"),
          getLabel: () => "",
          type: BUTTON_TYPES.DROPDOWN,
          modal: LineSpacingPanel,
          onSelect: updateSpacing
        }
      }
    }),
    name: "line-spacing"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
